import React, { useState } from 'react';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import PlayArrowIcon from '@material-ui/icons/PlayArrow';
import uniq from 'lodash/uniq';
import humanDuration from 'humanize-duration';
import { toUserTimezone } from 'utils';
import Button from 'components/common/Button';
import { ReactComponent as VideocamIcon } from 'assets/icons/video.svg';
import Divider from '@material-ui/core/Divider';
import { makeStyles } from '@material-ui/core/styles';
import { useSelector } from 'react-redux';
import ViewRecording from './ViewRecoding';
import apiClient from 'utils/api-client';
import useSnack from 'hooks/useSnack';

const useStyles = makeStyles((theme) => ({
  listHeader: {
    marginBottom: theme.spacing(3),
  },
  listTitle: {
    color: theme.palette.text.secondary,
    fontWeight: 700,
    textTransform: 'uppercase',
    fontSize: 12,
    letterSpacing: 2,
  },
  cover: {
    'backgroundColor': theme.palette.background.paper,
    'border': '1px solid',
    'borderColor': theme.palette.action.disabledBackground,
    'width': 160,
    'height': 90,
    'color': theme.palette.background.paper,
    'display': 'flex',
    'alignItems': 'center',
    'justifyContent': 'center',
    'marginRight': theme.spacing(3),
    'flexShrink': 0,
    '& svg': {
      backgroundColor: theme.palette.primary.main,
    },
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  item: {
    [theme.breakpoints.down('sm')]: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: '0px 5px 20px rgba(158, 158, 158, 0.1)',
      borderRadius: 6,
      padding: theme.spacing(2),
    },
  },
  video:{
    marginRight: theme.spacing(1),
    '& path':{
      fill: theme.palette.primary.main
    }
  }
}));

const SessionsHistory = ({ conferences }) => {
  const classes = useStyles();
  const user = useSelector((s) => s.user.user);
  const [showModal, toggleModal] = useState(false);
  const snack = useSnack();

  const closeModal = () => {
    toggleModal(false);
  };

  const onDownload = (conf) => {
    return  apiClient.get(`/twilio/video/${conf.id}/download`).then(
      (resp) => {
        window.open(resp.url);
      },
      (e) => {
        snack.error(e.message);
      },
    );
  }

  return (
    <Box>
      <Typography variant="h5" className={classes.listHeader}>
        Session History
      </Typography>
      <Box display={{ xs: 'none', sm: 'block' }} marginBottom={2}>
        <Grid container spacing={1}>
          <Grid item sm={6} md={7}>
            <Typography className={classes.listTitle}>Session</Typography>
          </Grid>
          <Grid item md={4}>
            <Typography className={classes.listTitle}>Date</Typography>
          </Grid>
        </Grid>
      </Box>
      {conferences.map((c) => (
        <Box key={c.id} marginBottom={3} className={classes.item}>
          <Box marginBottom={{ sm: 2 }}>
            <Grid container spacing={1}>
              <Grid item xs={12} sm={6} md={5}>
                <Box display="flex">
                  <Box className={classes.cover}>
                    <PlayArrowIcon color="inherit" />
                  </Box>
                  <Box>
                    <Typography variant="body2">
                      Session with{' '}
                      {uniq(
                        c.conference_participants.map(
                          (u) =>
                            `${u.user.user_first_name} ${u.user.user_last_name}`,
                        ),
                      ).join(', ')}
                    </Typography>
                    <Typography gutterBottom variant="caption">
                      Duration: {humanDuration(c.duration * 1000)}
                    </Typography>
                  </Box>
                </Box>
              </Grid>
              <Grid item md={2}></Grid>
              <Grid item xs={12} item sm={3} md={3}>
                <Typography variant="caption">
                  {toUserTimezone(c.created_at, user.timezone).format('LL')}
                </Typography>
              </Grid>
              <Grid item xs={12} sm={3} md={2} style={{ textAlign: 'center' }}>
                <Box display={{ xs: 'block', sm: 'none' }} marginY={1}>
                  <Divider />
                </Box>
                <Button
                  startIcon={<VideocamIcon className={classes.video}/>}
                  color="primary"
                  onClick={() => toggleModal(c)}
                >
                  Play Session
                </Button>
                {user.type === 'admin' && (
                  <Button color="primary" variant="outlined" onClick={() => onDownload(c)}>Download</Button>
                )}
              </Grid>
            </Grid>
          </Box>
          <Box display={{ xs: 'none', sm: 'block' }}>
            <Divider />
          </Box>
        </Box>
      ))}
      {showModal && <ViewRecording data={showModal} onClose={closeModal} />}
    </Box>
  );
};

export default SessionsHistory;
